/**
 * Supported ISO 639 language codes for order management.
 */
export enum SupportedLanguages {
    CS = 'cs', // Czech
    DA = 'da', // Danish
    DE = 'de', // German
    EN = 'en', // English (US)
    EN_GB = 'en-gb', // English (United Kingdom)
    ET = 'et', // Estonian
    FI = 'fi', // Finnish
    FR_BE = 'fr-be', // French (Belgium)
    LT = 'lt', // Lithuanian
    LV = 'lv', // Latvian
    NL = 'nl', // Dutch (Netherlands)
    NL_BE = 'nl-be', // Dutch (Belgium)
    NO = 'no', // Norwegian
    PL = 'pl', // Polish
    SV = 'sv', // Swedish
    TR = 'tr' // Turkish
}
